import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import * as yup from "yup";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useEffect, useState } from "react";
import Input, { NuInput, NuInputWithError, NuSelect, NuTextArea } from "../../../../Components/Utils/Input";
import UseEditData from "../../../../Components/Hooks/useEditData";
import { useLocation, useParams } from "react-router-dom";
import FormikSelectTwo, { SelectProductWithError } from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../Components/Utils/selectAddMetaData";
import DeleteIcon from "../../../../Components/Icons/Delete";
import EditIcon from "../../../../Components/Icons/Edit";
import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import Select from "react-select";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement, { videotype } from "../../../../Components/Utils/CustomAttrachmentupload";
import Doc from "../../../../Components/Icons/Doc";
import Xls from "../../../../Components/Icons/Xls";
import Txt from "../../../../Components/Icons/Txt";
import Pdf from "../../../../Components/Icons/Pdf";
import Video from "../../../../Components/Icons/Video";
import CloseIcon from "../../../../Components/Icons/Close";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "PDF",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];
const EditRequest = () => {
  
  const {officeId} =useParams();
 const [items, setItems] = useState([]);
  const [remove, setRemove] = useState([]);
  const [isEditQua, setIsEditQua] = useState(false);
  const [isEditReturnQua, setisEditReturnQua] = useState(false);

  const [isEditUnit, setIsEditUnit] = useState(false);
  const [combinedItems, setCombinedItems] = useState([]);
  // console.log(items, "kk");
  // console.log(data, "pp");
  const [newItemData, setNewItemData] = useState({
    productId:"",
    purpose:"",
    quantity:"",
    returnedQty:"",
    unit:""
  });
  const [search, setSearch] = useState("");
 
  const { data: Item, setData } = UseProductDropDownNew(
    `/items/new-drop-down/${officeId}/branch`,

    search
  );
  // const {value:Unit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
  const {value:RequestFor} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestFor')
  const {value:PurposeOfRequest} = useFetchMataData(`/dropdown/dropdown-details/`,'PurposeOfRequest')
  const {value:RequestStatus,getData:refRequestStatus} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestStatus')
  // const [loading, setLoading] = useState(false);

  const { Oncancel, editData, contextHolder, isLoading } = UseEditData();
    const location = useLocation();
    const data = location.state.data;
    const from = location.state.from;
  const [dataa, setDatas] = useState(data);

  const [createNew, setCreateNew] = useState({
    requestFor: data?.requestFor || "",
    purpose: data?.purpose || "",
    isReturnable: data?.isReturnable || "",
    item: data?.item || "",
    comments: data?.comments || "",
    quantity: data?.quantity || "",
    unit: data?.unit || "",
    approvedBy: data?.approvedBy || "",
    reviewedBy : data?.reviewedBy || "",
    preparedBy: data?.preparedBy || "",
    issueedBy: data?.issueedBy || "",
    status: data?.status || ""

  });
    const [fileRemoveList, setFileRemoveList] = useState([]);
   const [selectedFile, setSelectedFile] = useState(null);
    const [filePathList, setFilePathList] = useState([]);
    const [removefilePathList, setRemoveFilePathList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [fileExtention, setFileExtention] = useState("");
    const toast = useToast();
    const [image, setImage] = useState([]);
  
   function handleImageChange(e) {
  const maxFileSize = 200000000; // 200 MB
  const files = Array.from(e.target.files);
  let fileArr = [];

  files.forEach((item) => {
    if (item.size < maxFileSize) {
      fileArr.push(item);
    } else {
      toast.open({
        type: "warning",
        message: `File Size too big`,
        description: `${item.name} is removed and not uploaded`,
      });
    }
  });

  let tempArr = [];
  setSelectedFile(fileArr);

  fileArr.forEach((item) => {
    let fileName = item?.name;
    tempArr.push(fileName);
  });

  setImage(tempArr);
  console.log(tempArr, "temp");

  // 👉 Reset input so same file can be selected again
  e.target.value = null;
}

 const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      tempArr.push(fileName);
    });
    setImage(tempArr);
  };
  
    useEffect(() => {
      if (
        data?.attachments !== null &&
        data?.attachments !== "None" &&
        data?.attachments !== "[]"
      ) {
        console.log(data.attachments, "ghjkllgd");
        setFilePathList(data?.attachments);
  
        setRemoveFilePathList(data?.attachments);
      }
    }, [data]);
  
    function UpdateAttachmentList(item) {
      let filterList = filePathList.filter((itemList) => itemList.file !== item);
      let removeFile = filePathList.find((itemList) => itemList.file === item);
      console.log("llll", filterList);
      setFileRemoveList([...fileRemoveList, removeFile.file]);
      setFilePathList(filterList);
    }
  
    function handleImageClick(img) {
      let Ext = img?.file_name.split(".").reverse()[0];
      setSelectedImage(img);
      setFileExtention(Ext);
      setIsModalOpen(true);
    }
  
    const selectedProductIds = [
      ...items?.map((item) => item.productId),
      ...dataa.products.map((product) => product.productId),
    ];
  
    // Step 2: Filter out the selected products from the dropdown options
    const filteredOptions = Item.filter(
      (product) => !selectedProductIds.includes(product.value)
    );
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // item: yup.string().required('Product is required!'),
      // quantity: yup.string().required('Quantity is required!'),

    }),
    onSubmit: async (value, { resetForm }) => {
      // setLoading(true)
      if (items.length === 0 && data?.products?.length === 0) {
        setError("Product table is empty");
        return;
      }
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        products: combinedItems,
        removedProducts: remove,
        filesToRemove: fileRemoveList,
      };

      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      editData(`/requests/edit-request/${data.requestId}`, formData, resetForm, from)
      // setLoading(false)

      
    },
    
  });
  const { data: user } = UseDropDown('/user/drop-down');
 
  const { value: Unit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Unit_item"
  );

  useEffect(() => {
    if (formik.values.item) {
      const selectedProduct = items.find((i) => i.value === formik.values.item);
      if (selectedProduct) {
        formik.setFieldValue('unit', selectedProduct.unit);
      }
    }
  }, [formik.values.item, items]);

  const [sortedProList,setSortedProList] =  useState([]);
  const [oldData, setOldData] = useState([])
 

  const [error, setError] = useState("");
    const [productError, setProductError] = useState("");
    const [unitError, setUnitError] = useState("");
    const [quantityError, setQuantityError] = useState("");
    const handleAdd = () => {
      let hasError = false;
  
      if (!formik.values.productId) {
        setProductError("Product is required");
        hasError = true;
      } else {
        setProductError("");
      }
  
      if (!formik.values.unit) {
        setUnitError("Unit is required");
        hasError = true;
      } else {
        setUnitError("");
      }
  
      if (!formik.values.quantity) {
        setQuantityError("Quantity is required");
        hasError = true;
      } else {
        setQuantityError("");
      }
  
      if (hasError) return;
  
      if (formik.values.productId && formik.values.quantity) {
        const selectedProduct = Item.find(
          (i) => i.value === formik.values.productId
        );
        const newItem = {
          productId: formik.values.productId,
          productName: sortedProList.find((i) => i.value === formik.values.productId),
          quantity: formik.values.quantity,
          // unit: selectedProduct.unit,
          unit: formik.values.unit,
        };
        setItems([...items, newItem]);
  
        setNewItemData({
          productId: "",
          unit: "",
          quantity: "",
        });
        let updatedItems = Item.filter(
          (it) => it.value !== formik.values.productId
        );
        setData(updatedItems);
        formik.values.productId = "";
        formik.values.quantity = "";
        formik.values.unit = "";
  
        setError("");
      }
    };
  
    const handleQuantityChange = (e, index) => {
      const updatedQuantity = e.target.value;
  
      const updatedItems = items.map((item, idx) => {
        if (idx === index) {
          return { ...item, quantity: updatedQuantity };
        }
        return item;
      });
  
      setItems(updatedItems);
    };

    const handleReturnQuantityChange = (e, index) => {
      let updatedQuantity = parseInt(e.target.value, 10) || "";
      updatedQuantity = Math.max("", updatedQuantity); 
    
      setItems((prevItems) =>
        prevItems.map((item, idx) =>
          idx === index
            ? {
                ...item,
                returnedQty: updatedQuantity > item.quantity ? item.quantity : updatedQuantity, 
              }
            : item
        )
      );
    };
    
  
    const handleDeleteItem = (indexToDelete) => {
      const updatedItems = items.filter((_, index) => index !== indexToDelete);
      let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
      setItems(updatedItems);
      let tempDd = ddUpdatedItem.productName;
      setData([...Item, tempDd]);
      // localStorage.setItem("items", JSON.stringify(updatedItems));
    };

     const handleProductUnitChange = (value, index) => {
        const updatedItems = items.map((item, idx) => {
          if (idx === index) {
            return { ...item, unit: value?.value };
          }
          return item;
        });
        setItems(updatedItems);
      };
    
    
    
      useEffect(()=>{
        const filterdItem = Item.filter(
          (drop) => !dataa?.products?.some((id) => id.productId === drop.value)
        );
        if(Item){
          const union = Array.from(
            new Map([...filterdItem, ...oldData].map((item) => [item.value, item])).values()
          );
          let data = union.sort((a, b) => a.label.localeCompare(b.label))
          setSortedProList(data)
        }
        console.log("item",Item);
        
      },[Item])
    
      useEffect(() => {
        if (formik.values.productId) {
          const findValue = sortedProList.filter((v) => formik.values?.productId ==(v.value));
          console.log("final",findValue);
          
          setOldData(findValue);
        }
        console.log("Testing",formik.values.productId);
      },[formik.values.productId])
    
    const [finalList, setFinalList] = useState(dataa?.products);
    
    const handleReturnQuantityChangeAlredyExit = (e, index) => {
      const updatedItems = [...finalList];
      let updatedQuantity = parseInt(e.target.value, 10) || "";
      updatedQuantity = Math.max("", updatedQuantity); 
    
     
      updatedItems[index].returnedQty =
        updatedQuantity > updatedItems[index].quantity ? updatedItems[index].quantity : updatedQuantity;
    
      setFinalList(updatedItems);
    };
    
    
      const handleQuantityChangeAlredyExit = (e, index) => {
        const updatedItems = [...finalList];
        updatedItems[index].quantity = e.target.value;
        setFinalList(updatedItems);
        console.log("shsd", finalList);
      };
    

      const handleProductUnitChangeAlredyExit = (value, index) => {
        const updatedItems = [...finalList];
        updatedItems[index].unit = value?.value;
        setFinalList(updatedItems);
        console.log("shsd", finalList);
      };
    
      console.log("sss", dataa?.products);
      console.log("ddd", items);
    
      useEffect(() => {
        if (dataa?.products && items) {
          const mergedArray = [...dataa.products, ...items];
          setCombinedItems(mergedArray);
        }
      }, [dataa?.products, items]);
      const handleDelete = (productId) => {
        const updatedproducts = dataa?.products.filter(
          (item) => item.productId !== productId
        );
        // const deletedItem = dataa?.products.find(item => item.productId === productId);
        console.log(updatedproducts, "lll");
    
        setDatas((prevState) => ({
          ...prevState,
          products: updatedproducts,
        }));
        setRemove([...remove, productId]);
    
        // setremove(prevState => ({
        //   ...prevState,
        //   removedProducts: [...prevState.removedProducts, deletedItem]
        // }));
      };
  
  return (
    <div className="w-full h-full py-2 px-4 ">
    <div className="flex justify-end ">
    {/* <Breadcrumb
         items={
          [
            { name: "Store",
            link: `/main/${officeId}/store/requests` }, 
          {
            name: "Request",
            link: `/main/${officeId}/store/requests`
          },
          {
            name: "Edit Request"
          }]
         }
        /> */}
        <BackButton />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
          <div className=" w-full h-full py-4 px-3 flex justify-start content-start flex-wrap  overflow-y-auto">
          <div className="w-full">
  <p className='py-2 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4'>
 Request Edit :
  </p>
</div> 
                     {/* <FormikSelectTwo
                      label="Product"
                      placeholder="Choose"
                      Options={items}
                      formik={formik}
                      name="item"
                      width="w-full md:w-1/2 lg:w-1/3"
                      isRequired={true}
                    /> */}
                     {/* <FormikSelectTwo
                label="Unit"
                placeholder="Choose"
                Options={Unit}
                formik={formik}
                name="unit"
                width="w-full md:w-1/2 lg:w-1/3"
              /> */}
                    {/* <NuInput
                      type="number"
                      label="Quantity"
                      placeholder="Quantity"
                      formik={formik}
                      isRequired={true}
                      name="quantity"
                      width="w-full md:w-1/2 lg:w-1/3"
                    /> */}
          <FormikSelectTwo
              type="text"
              label="Request For"
              placeholder="Choose"
              Options={RequestFor}
              formik={formik}
              name="requestFor"
              width="w-full md:w-1/2 lg:w-1/3"
              FixPosition={true}
                PortalTarget={false}
            />  
             <FormikSelectTwo
              type="text"
              label="Purpose Of Request"
              placeholder="Choose"
              Options={PurposeOfRequest}
              formik={formik}
              name="purpose"
              width="w-full md:w-1/2 lg:w-1/3"
              FixPosition={true}
                PortalTarget={false}
            />  
                    <FormikSelectTwo
                      type="text"
                      label="Is Returnable"
                      placeholder="Choose"
                      Options={[
                        { value: true , label: "Yes"},
                        { value: false , label: "No"},
                      ]}
                      formik={formik}
                      name="isReturnable"
                      width="w-full md:w-1/2 lg:w-1/3"
                      FixPosition={true}
                PortalTarget={false}
                    />
                   
                    <FormikSelectTwo
                      type="text"
                      label="Issued By"
                      placeholder="Choose"
                      Options={user}
                      formik={formik}
                      name="issueedBy"
                      width="w-full md:w-1/2 lg:w-1/3"
                      FixPosition={true}
                PortalTarget={false}
                    /> 
                     <DropDownAddMetaData
                label="Status"
                placeholder="Choose"
                Options={RequestStatus}
                formik={formik}
                name="status"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refRequestStatus}
                displayProperty={"Status"}
                propertyName={"RequestStatus"}
                FixPosition={true}
                PortalTarget={false}
              />   
                     {/* <FormikSelectTwo
              type="text"
              label="Status"
              placeholder="Choose"
              Options={RequestStatus}
              formik={formik}
              name="status"
              width="w-full md:w-1/2 lg:w-1/3"
            />                 */}
                    <NuTextArea
                      label="Comments"
                      placeholder="Comments"
                      formik={formik}
                      name="comments"
                      width="w-full md:w-1/2 lg:w-1/3"
                    /> 
                     <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <div className="md:flex justify-between mt-5 px-3 w-full">
                <div className="w-full flex gap-2 items-center flex-wrap">
                  {data?.attachments &&
                    filePathList?.map((imgs, idx) => {
                      console.log("img", imgs);
                      let Ext = imgs?.file_name.split(".").reverse()[0];
                      return (
                        <div
                          className=" w-20 h-9 my-2 relative flex justify-center items-center rounded-lg"
                          key={idx}
                          style={{
                            border: "1px solid gray",
                            borderColor:
                              "rgb(148 163 184 / var(--tw-bg-opacity))",
                          }}
                        >
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-medium flex justify-center items-center  -top-2 -right-2 z-10"
                            onClick={() => UpdateAttachmentList(imgs?.file)}
                          >
                            <CloseIcon color="white" height="8" width="8" />
                          </div>
                          <div
                            className=" w-20 h-9 flex justify-center items-center rounded-lg overflow-hidden cursor-pointer"
                            onClick={() => handleImageClick(imgs)}
                          >
                            <div className=" w-8 h-8">
                              {videotype.includes(Ext) ? <Video /> : null}

                              {Ext === ("docx" || "doc" || "txt") ? (
                                <Doc />
                              ) : Ext === ("xlsx" || "xls") ? (
                                <Xls />
                              ) : Ext === "txt" ? (
                                <Txt />
                              ) : Ext === "pdf" ? (
                                <Pdf />
                              ) : Ext === "PDF" ? (
                                <Pdf />
                              ) : Ext === "pptx" ? (
                                <>No file</>
                              ) : (
                                <img src={imgs?.file} alt="#" width="120%" />
                              )}
                            </div>
                            <p className=" w-[50px] text-[11px] truncate">
                              {imgs?.file_name}
                            </p>
                          </div>
                        </div>
                      );
                    })}

                  <Attachement
                    handleChange={handleImageChange}
                    preview={image || ""}
                    width="w-full md:w-1/2"
                    label="Attach"
                    multiple={true}
                removeImages={removeImages}

                  />
                </div>
              </div>   
                <div className="w-full mx-auto h-auto bg-white rounded-md overflow-hidden mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  overflow-y-auto mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Request Items :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={() => {}}
                  hasAddButton={false}
                  setSearch={setSearch}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  // getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  hasAddButton={false}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />

                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-10 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-hidden mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-textColor-main flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Return Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setisEditReturnQua((prv) => !prv);
                      }}
                    >
                      {isEditReturnQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditReturnQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 || dataa.products?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName.label}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                Unit.find(
                                  (item) => item?.value == List?.unit
                                ) || List?.unit
                              }
                              options={isEditUnit ? Unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity || ""}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.returnedQty || ""}
                              disabled={!isEditReturnQua}
                              onChange={(e) => handleReturnQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                    {dataa?.products?.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1 + items.length}
                          </p>
                          <p className=" w-[55%] text-left  text-xs  font-medium text-[#111537] py-2.5">
                            {List?.product_name}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            <Select
                              value={
                                Unit.find(
                                  (item) => item?.value == List?.unit
                                ) || List?.unit
                              }
                              options={isEditUnit ? Unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChangeAlredyExit(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) =>
                                handleQuantityChangeAlredyExit(e, index)
                              }
                            />
                          </p>
                          <p className=" w-[20%] text-center  text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className="w-11/12 mx-auto outline-none text-center"
                              value={List?.returnedQty}
                              disabled={!isEditReturnQua}
                              onChange={(e) =>
                                handleReturnQuantityChangeAlredyExit(e, index)
                              }
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDelete(List?.productId)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}

                {/* </div> */}
              </div>
             
            </div>
          </div>        
            <div className="w-full mx-auto my-4 mt-8 ">
              <div className="flex justify-end gap-4">
                <CancelButton handleClick={()=>{Oncancel(-1)}} />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditRequest;
